import { render, staticRenderFns } from "./setOfficialAccount.vue?vue&type=template&id=6a5c3cb1&scoped=true"
import script from "./setOfficialAccount.vue?vue&type=script&lang=js"
export * from "./setOfficialAccount.vue?vue&type=script&lang=js"
import style0 from "./setOfficialAccount.vue?vue&type=style&index=0&id=6a5c3cb1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5c3cb1",
  null
  
)

export default component.exports